{
  "longPressMessage": "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
}
